export function parseCustomerAddress(value) {
  if (!value) return {};
  if (typeof value === "object") return value;
  try {
    const parsed = JSON.parse(value);
    return parsed && typeof parsed === "object" ? parsed : { addressLine: String(parsed || "") };
  } catch {
    return { addressLine: value };
  }
}
